(() => {
  const key = 'filter.p.m.custom.game';
  const games = ['Riftbound', 'Pokemon', 'One Piece', 'Dragon Ball', 'Gundam', 'Digimon'];
  const formatTypes = Object.freeze({
    'single-card': Object.freeze(['Single Card']),
    sealed: Object.freeze(['Booster Pack', 'Booster Box', 'Sealed Product', 'Champion Deck']),
    accessory: Object.freeze(['Accessory', 'DIY Product']),
    merchandise: Object.freeze(['Merchandise']),
    'graded-card': Object.freeze(['Graded Card'])
  });
  const aliases = {singles:'single-card', graded:'graded-card', accessories:'accessory', preorders:'preorder', all:''};
  const values = (params, name) => [...new Set(params.getAll(name).flatMap(value => value.split(',')).filter(Boolean))];
  function format(params) {
    const hasNative = params.has('filter.p.product_type');
    const types = values(params, 'filter.p.product_type');
    const requested = params.get('format') || '';
    const legacy = Object.hasOwn(aliases, requested) ? aliases[requested] : requested;
    const inferred = types.length ? Object.keys(formatTypes).find(name => types.every(type => formatTypes[name].includes(type))) || '' : '';
    const selected = legacy === 'preorder' ? legacy : hasNative ? inferred : Object.hasOwn(formatTypes, legacy) ? legacy : '';
    return {format:selected, hasNative, types:hasNative ? types : [...(formatTypes[selected] || [])]};
  }
  function read(params, fallback = '') {
    const hasNative = params.has(key);
    const nativeValues = values(params, key);
    const selected = hasNative ? nativeValues.length === 1 ? nativeValues[0] : '' : params.get('game') || fallback;
    const game = games.includes(selected) ? selected : '';
    return {game, hasNative, values: hasNative ? nativeValues : game ? [game] : []};
  }
  function normalize(params) {
    const result = new URLSearchParams(params);
    const scope = read(result);
    if (!scope.game) result.delete('game');
    if (scope.hasNative || scope.game) {
      result.delete('game');
      result.delete(key);
      scope.values.forEach(value => result.append(key, value));
      if (!scope.values.length) result.set(key, '');
      if (scope.game) result.set('game', scope.game);
    }
    const typeScope = format(result);
    result.delete('format');
    if (typeScope.format) result.set('format', typeScope.format);
    if (typeScope.hasNative || typeScope.types.length) {
      result.delete('filter.p.product_type');
      typeScope.types.forEach(type => result.append('filter.p.product_type', type));
      if (!typeScope.types.length) result.set('filter.p.product_type', '');
    }
    return result;
  }
  window.ScSearchScope = Object.freeze({read, normalize, values, format, formatTypes});
})();
